document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector('.header');
    const contentSections = document.querySelectorAll('.section'); // Adjust selector for your content sections

    const changeHeaderColor = (isDark) => {
        if (isDark) {
            header.classList.add('header--dark');
            header.classList.remove('header--light');
        } else {
            header.classList.add('header--light');
            header.classList.remove('header--dark');
        }
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const isDarkBackground = entry.target.classList.contains('dark-background'); // Add a class to your dark sections
                changeHeaderColor(isDarkBackground);
            }
        });
    }, { threshold: 0.1 });

    contentSections.forEach((section) => {
        observer.observe(section);
    });
});